export default {
  whatSearch: 'Cosa stai cercando?',
  products: 'Prodotti',
  filtersBy: 'Filtra per',
  delete: 'Annulla',
  popularSearch: 'Ricerche popolari',
}
